var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
const queryMe = `
	query queryMe {
		me {
			id
			type
			firstName
			lastName
			email {
				address
				isVerified
				verifiedDate
			}
			phone {
				isVerified
				number
				verifiedDate
			}
		}
	}			
`;
const mutateMe = `
	mutation updateMe($me: PersonInput!) {
		updateMe(me: $me) {
			id
			type
			firstName
			lastName
			email {
				address
				isVerified
				verifiedDate
			}
			phone {
				isVerified
				number
				verifiedDate
			}
		}
	}
`;
const mutateValidateUpdatePerson = `
	mutation validateUpdateMe($me: PersonInput!) {
		validateUpdateMe(me: $me) {
			email
			phoneNumber
		}
	}
`;
const gql = (uri, query, variables, headers) => axios({
    method: 'post',
    url: `${uri}/graphql`,
    data: {
        query,
        variables,
    },
    headers,
});
const post = (uri, data = {}, headers = {}) => axios({
    method: 'post',
    url: `${uri}`,
    data,
    headers,
});
const tryGetAuthorizationHeaders = () => __awaiter(void 0, void 0, void 0, function* () {
    const { token } = yield window.gdiHost.getAccessToken();
    return token ? {
        Authorization: `Bearer ${token}`,
    } : {};
});
export const createGqlContext = (uri) => ({
    getPerson: () => tryGetAuthorizationHeaders()
        .then(headers => gql(uri, queryMe, {}, headers))
        .then(response => { var _a, _b; return (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.me; }),
    updatePerson: (input) => tryGetAuthorizationHeaders()
        .then(headers => gql(uri, mutateMe, { me: input }, headers))
        .then(response => {
        var _a, _b, _c, _d;
        return ({
            person: (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.updateMe,
            errorField: ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.errors) === null || _d === void 0 ? void 0 : _d.map((e) => { var _a; return (_a = e === null || e === void 0 ? void 0 : e.extensions) === null || _a === void 0 ? void 0 : _a['validation-failed-for-field']; }).filter((f) => f)[0]) || null,
        });
    }),
    sendVerificationLink: (type) => tryGetAuthorizationHeaders()
        .then(headers => {
        post(`${uri}/send-verification-notification/${type}`, {}, headers);
    }),
});
